'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'socks';
var width = 512;
var height = 512;
var aliases = [129510];
var unicode = 'f696';
var svgPathData = 'M240 0l0 64-112 0 0-64 112 0zm0 112l0 136-70.4 52.8c-36.3 27.2-57.6 69.9-57.6 115.2 0 31.9 10.4 61.4 28 85.3-13.5 7-28.6 10.7-44 10.7-53 0-96-43-96-96 0-30.2 14.2-58.7 38.4-76.8l89.6-67.2 0-160 112 0zm48 0l192 0 0 256-166.4 124.8c-16.6 12.5-36.8 19.2-57.6 19.2-53 0-96-43-96-96 0-30.2 14.2-58.7 38.4-76.8L288 272 288 112zM480 64l-192 0 0-64 192 0 0 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSocks = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;